// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"Footer_socialIcon__1Cc0G","footerLogo":"Footer_footerLogo__2TNvs"};